export default __webpack_public_path__ + "static/cover-2c19bf5899768dda55fe1d2d24324cca.png";